import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import { celebrationTypes } from "../../data/homeContent";
import { eventInquiryContact } from "../../data/eventInquiry";
import { Calavera } from "../culture/Calavera";
import { PapelPicado } from "../culture/PapelPicado";
export function CelebrationSection() {
  const {
    t
  } = useSite();
  const reduceMotion = useReducedMotion();
  return <section aria-labelledby="celebration-heading" className="relative overflow-hidden bg-marigold text-agavedeep" data-id="element-229" data-mp="22xktjs8phj59">
      <PapelPicado data-id="element-230" data-mp="1t5oqs3vod4up" />
      <div className="mx-auto max-w-4xl px-5 pb-20 pt-8 sm:px-8 lg:pb-28" data-id="element-231" data-mp="1t55bkuxesukd">
        <motion.div initial={reduceMotion ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-232" data-mp="2gv9dmxuy8m99">
          <div className="flex items-center gap-3" data-id="element-233" data-mp="au4yd5u8lyb4">
            <Calavera className="h-11 w-9" data-id="element-234" data-mp="5v27cpb3dsm5" />
            <p className="text-xs font-bold uppercase tracking-[.22em]" data-id="element-235" data-mp="5w3jyy7ran5z">
              {t("Events & Catering", "Eventos y Catering")}
            </p>
          </div>
          <h2 id="celebration-heading" className="mt-4 font-serif text-[44px] font-bold leading-[0.95] sm:text-6xl" data-id="element-236" data-mp="euynu3nbvl64">
            {t("Bring Blue Agave to Your Celebration", "Lleva Blue Agave a tu celebración")}
          </h2>
          <p className="mt-5 font-serif text-2xl italic leading-snug text-agavedeep/90" data-id="element-237" data-mp="ok8jtulalnzi">
            {t("Flavor, tradition and fiesta — wherever you celebrate.", "Sabor, tradición y fiesta — donde sea que celebres.")}
          </p>

          <ul className="mt-8 grid grid-cols-2 gap-x-4 gap-y-3 border-y border-agavedeep/20 py-6 text-[15px] font-semibold" data-id="element-238" data-mp="34be9lyc3vhvm">
            {celebrationTypes.map((type, index) => <li key={type[0]} className="flex items-center gap-2.5" data-id="element-239" data-mp="13a6ny7m7kai9" data-mpi={index}>
                <span aria-hidden="true" className={`h-2.5 w-2.5 flex-none rotate-45 ${index % 3 === 0 ? "bg-chili" : index % 3 === 1 ? "bg-talavera" : "bg-cream"}`} data-id="element-240" data-mp="13cayh8em47ri" />
                {t(...type)}
              </li>)}
          </ul>

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-241" data-mp="1i54hh3t3f60x">
            <Link to="/catering" className="inline-flex min-h-12 items-center gap-2 rounded-full bg-agavedeep px-7 font-bold text-cream transition-[background-color,transform] duration-150 hover:bg-[#0B2C22] active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream" data-id="element-242" data-mp="1m7rcfdl2972c">
              {t("Plan Your Event", "Planea tu evento")}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-243" data-mp="25xta2zlhdr89" />
            </Link>
            <a href={eventInquiryContact.phoneHref} className="inline-flex min-h-12 items-center gap-2 rounded-full border border-agavedeep/40 px-6 font-bold transition-colors hover:bg-agavedeep/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-agavedeep" data-id="element-244" data-mp="29xlp9v5dqvml">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-245" data-mp="3lgiuoivpxaxr" />
              {eventInquiryContact.phone}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}